import { ReactNode, useEffect } from 'react';

type LeadModalProps = {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
};

// Coquille de modale réutilisable : fond assombri, fermeture au clic extérieur
// et à la touche Échap, blocage du défilement de la page tant qu'elle est ouverte.
export default function LeadModal({ open, onClose, children }: LeadModalProps) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = previousOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-start md:items-center justify-center p-4">
      <button
        type="button"
        aria-label="Fermer"
        onClick={onClose}
        className="absolute inset-0 bg-foreground-950/60 cursor-default"
      />
      <div
        role="dialog"
        aria-modal="true"
        className="relative w-full max-w-2xl max-h-[90vh] overflow-y-auto bg-background-50 rounded-2xl border border-background-200 animate-fade-up"
      >
        <button
          type="button"
          aria-label="Fermer la fenêtre"
          onClick={onClose}
          className="sticky top-4 float-right mr-4 z-10 w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 border border-background-300 text-foreground-700 transition-colors cursor-pointer"
        >
          <i className="ri-close-line text-lg w-5 h-5 flex items-center justify-center" />
        </button>
        <div className="px-6 md:px-8 py-7 md:py-8">{children}</div>
      </div>
    </div>
  );
}